import React, {FC} from 'react';

import {DropdownItemContent} from '../../../libs/shared/ui/src/components/dropdowns/dropdownItemContent';
import {VisualSizesEnum} from '../../../libs/shared/ui/src/styles/commonStyles';
import {TeammateAvatar} from '../../components/common/avatars/teammateAvatar';
import {DropdownItemAvatar} from '../../components/common/dropdowns/dropdownItemAvatar';
import {buildTeammateDisplayName} from '../../helpers/modelHelpers';
import {TeammateModel} from '../../models/api/teammateModel';

/*
 * Props.
 */

interface CircleEditorTeammateDropdownRowProps {
  teammate: TeammateModel;
  isChecked: boolean;
}

/*
 * Component.
 */

export const CircleEditorTeammateDropdownRow: FC<CircleEditorTeammateDropdownRowProps> = (props) => {
  const {teammate, isChecked} = props;

  return (
    <>
      <DropdownItemAvatar>
        <TeammateAvatar teammate={teammate} size={VisualSizesEnum.MEDIUM} />
      </DropdownItemAvatar>
      <DropdownItemContent isChecked={isChecked}>{buildTeammateDisplayName(teammate)}</DropdownItemContent>
    </>
  );
};
